import { useParams } from "react-router-dom";
import { useDateFromSearchParams, useResourceOpportunities } from "@/helpers/useTimeHooks";
import { ResourceType } from "@/pages/explorer/types";
import { InsightSection } from "@/pages/query/components";
import { WarehouseDetails } from "../../types";
import dayjs from "dayjs";
import { RelativeComponentLoader } from "@/components/loader";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { WarehouseTracking } from "@/lib/tracking/warehouse";

interface WarehouseOpportunitiesProps {
  warehouseDetails: WarehouseDetails;
}

const WarehouseOpportunities = ({ warehouseDetails }: WarehouseOpportunitiesProps) => {
  const { instance_id } = useParams<{ instance_id: string }>();
  const { searchParams, updateSearchParamsByKey } = useFiltersBySearchParams();
  const selectedOpportunityId = searchParams.get("opportunityId") || "";

  const {
    startDate: opportunityStartDate,
    endDate: opportunityEndDate,
    onUpdate: onDateRangeChange,
  } = useDateFromSearchParams(
    dayjs().subtract(1, "month").toDate(),
    dayjs().toDate(),
    "opportunity"
  );

  const opportunities = useResourceOpportunities({
    resourceUri: warehouseDetails.warehouse_name,
    resourceType: ResourceType.Warehouse,
    instanceId: instance_id,
    startDate: opportunityStartDate,
    endDate: opportunityEndDate,
  });

  const setSelectedOpportunityId = (opportunityId: string) => {
    WarehouseTracking.opportunitySelected(warehouseDetails.warehouse_name, opportunityId);
    updateSearchParamsByKey({ opportunityId });
  };

  if (opportunities.isFetching) {
    return <RelativeComponentLoader label={"Loading opportunities..."} componentHeight={40} />;
  }
  return (
    <InsightSection
      opportunities={opportunities.data?.data || []}
      selectedOpportunityId={selectedOpportunityId}
      setOpportunityId={setSelectedOpportunityId}
      startDate={opportunityStartDate}
      endDate={opportunityEndDate}
      onDateRangeChange={onDateRangeChange}
    />
  );
};

export default WarehouseOpportunities;
